import styled from "styled-components";
import { Divider as AntDivider } from "antd";
import { color } from "src/styles/globals";

const Divider = styled(AntDivider)`
  border-top: 1px solid ${color.charcoal03};
`;

export default Divider;
